// Ref: http://www.mikeobrien.net/blog/client-side-exception-logging-and-notification-in-angular/
window.onerror = function (message, source, line, column) {
    try {
        var escape = function (x) { return x.replace('\\', '\\\\').replace('\"', '\\"'); };
        var XHR = window.XMLHttpRequest || function () {
            try { return new ActiveXObject("Msxml3.XMLHTTP"); } catch (e0) { }
            try { return new ActiveXObject("Msxml2.XMLHTTP.6.0"); } catch (e1) { }
            try { return new ActiveXObject("Msxml2.XMLHTTP.3.0"); } catch (e2) { }
            try { return new ActiveXObject("Msxml2.XMLHTTP"); } catch (e3) { }
            try { return new ActiveXObject("Microsoft.XMLHTTP"); } catch (e4) { }
        };
        var xhr = new XHR();
        xhr.open('POST', '/errors/javascript', true);
        xhr.setRequestHeader('Content-type', 'application/json');
        var msg=message;
        // Log and return for now
        console.log(msg);
        return;
        // TODO: Add an api end point to receive the errors
        // xhr.send('{ ' +
        //     '"message": "' + escape(message || '') + '",' +
        //     '"source": "' + escape(source || '') + '",' +
        //     '"url": "' + escape(window.location.href) + '",' +
        //     '"line": "' + (line || 0) + '",' +
        //     '"column": "' + (column || 0) + '"' +
        // '}');
    }
    finally {
        window.onload = function () {
            if (document.getElementById('page-error')) return; // The error is already displayed
            var errorMessage = document.createElement('div');
            errorMessage.setAttribute('id', 'page-error');
            errorMessage.setAttribute('class', 'alert alert-danger col-md-4 space-left');
            errorMessage.innerHTML = [message, '\n', ' at line ', line].join('');                                       ;
            document.body.appendChild(errorMessage);
        }
    }
};